import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {StillImageBackground} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {BetLineWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetLineWinIndividualWPController";
import {FreespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinZeroBetController";
import {CCTwoBackground} from "./background/CCTwoBackground";
import {CCTwoBetlinesView} from "./betline/CCTwoBetlinesView";
import {CCTwoPolyBetLine} from "./betline/line/CCTwoPolyBetLine";
import {CCTwoTextBetLineNumber} from "./betline/number/CCTwoTextBetLineNumber";
import {CreepyCarnivalTwoFontConfig} from "./CreepyCarnivalTwoFontConfig";
import {CreepyCarnivalTwoGameAssets} from "./CreepyCarnivalTwoGameAssets";
import {CreepyCarnivalTwoGameConfig} from "./CreepyCarnivalTwoGameConfig";
import {CreepyCarnivalTwoSoundConfig} from "./CreepyCarnivalTwoSoundConfig";
import {CreepyCarnivalTwoIntroView} from "./intro/CreepyCarnivalTwoIntroView";
import {CCTwoMultiplierIndicator} from "./multiplier/CCTwoMultiplierIndicator";
import {CreepyCarnivalTwoReelController} from "./reel/reel/CreepyCarnivalTwoReelController";
import {CreepyCarnivalTwoReelAreaView} from "./reel/reelarea/CreepyCarnivalTwoReelAreaView";
import {CCTwoReelStopPresentationController} from "./reelstoppresentation/CCTwoReelStopPresentationController";
import {CreepyCarnivalTwoFreespinIntroController} from "./screen/freespinintro/CreepyCarnivalTwoFreespinIntroController";
import {CreepyCarnivalTwoFreespinIntroView} from "./screen/freespinintro/CreepyCarnivalTwoFreespinIntroView";
import {CCTwoFreespinOutroController} from "./screen/freespinoutro/CCTwoFreespinOutroController";
import {CreepyCarnivalTwoFreespinOutroView} from "./screen/freespinoutro/CreepyCarnivalTwoFreespinOutroView";
import {CreepyCarnivalTwoServerDataParser} from "./server/CreepyCarnivalTwoServerDataParser";
import {CreepyCarnivalTwoParsedGameData} from "./server/data/CreepyCarnivalTwoParsedGameData";
import {CreepyCarnivalTwoParsedInitData} from "./server/data/CreepyCarnivalTwoParsedInitData";
import {CreepyCarnivalTwoSpinController} from "./spin/CreepyCarnivalTwoSpinController";
import {StarSpinIntroController} from "./starspin/controller/StarSpinIntroController";
import {CCTWildStarSpinView} from "./starspin/view/CCTWildStarSpinView";
import {CreepyCarnivalTwoStarSpinIntroView} from "./starspin/view/CreepyCarnivalTwoStarSpinIntroView";
import {CCTwoStarStatusScreen} from "./starStatus/CCTwoStarStatusScreen";
import {CCTwoStarMeter} from "./startMeter/CCTwoStarMeter";
import {CCTwoBulb} from "./utils/CCTwoBulb";
import {CreepyCarnivalTwoBigWinController} from "./winpresentation/bigwin/CreepyCarnivalTwoBigWinController";
import {CCTwoIndividualPController} from "./winpresentation/individual/CCTwoIndividualPController";
import {CreepyCarnivalTwoInitialWPController} from "./winpresentation/initial/CreepyCarnivalTwoInitialWPController";
import {CCTwoNoWinSymbolsWinPresentationController} from "./winpresentation/nowinsymbols/CCTwoNoWinSymbolsWinPresentationController";
import {CreepyCarnivalTwoFSRespinZeroBetController} from "./zerobet/CreepyCarnivalTwoFSRespinZeroBetController";
import {CreepyCarnivalTwoMainRespinZeroBetController} from "./zerobet/CreepyCarnivalTwoMainRespinZeroBetController";

export class CreepyCarnivalTwoGameModuleConfig implements IGameModuleConfig {
    public static instance:CreepyCarnivalTwoGameModuleConfig = new CreepyCarnivalTwoGameModuleConfig();
    static background:StillImageBackground;
    static reelArea:StillImageBackground;
    public static starMeter:CCTwoStarMeter;
    private static wildStarSpin:CCTWildStarSpinView;
    public static starStatusScreen:CCTwoStarStatusScreen;
    private static backgroundM:CCTwoBackground;
    private static multiplierIndicator:CCTwoMultiplierIndicator;
    private static LOGO:StillImageBackground;
    private static bulbs:CCTwoBulb;
    private static betLinesView:CCTwoBetlinesView;

    GAME_CONFIG:IGameConfig = CreepyCarnivalTwoGameConfig.instance;
    FONTS_CONFIG:IFontsConfig = CreepyCarnivalTwoFontConfig.FONTS;
    SOUND_CONFIG:ISoundConfig = CreepyCarnivalTwoSoundConfig.instance;
    RESOURCES_CONFIG:IResourcesGroupConfig = CreepyCarnivalTwoGameAssets.RESOURCES_GROUPS;

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new FreespinZeroBetController(),
        () => new CreepyCarnivalTwoMainRespinZeroBetController(),
        () => new CreepyCarnivalTwoFSRespinZeroBetController()
    ];

    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        (index:number) => new CCTwoReelStopPresentationController(index, "reelAttention")
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new CCTwoNoWinSymbolsWinPresentationController(indexes, {noWinStateFadeInDuration : 0.5})],
        [indexes => new CreepyCarnivalTwoInitialWPController(indexes)],
        [indexes => new CreepyCarnivalTwoBigWinController(indexes)]
    ];

    SCREENS:(() => ScreenController)[] = [
        () => new StarSpinIntroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new CreepyCarnivalTwoStarSpinIntroView({
                    layer : CreepyCarnivalTwoGameConfig.instance.LAYERS.STAR_SPIN_INTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.9
                    },
                    mobileScale : 1.2,
                    portraitScale : 1.2
                }, autoClose);
            }
        }),
        () => new CreepyCarnivalTwoFreespinIntroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new CreepyCarnivalTwoFreespinIntroView({
                    layer : CreepyCarnivalTwoGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.9
                    },
                    mobileScale : 1.2,
                    portraitScale : 1.2
                }, autoClose);
            }
        }),
        () => new CCTwoFreespinOutroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new CreepyCarnivalTwoFreespinOutroView({
                    layer : CreepyCarnivalTwoGameConfig.instance.LAYERS.FREESPIN_OUTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.9
                    },
                    mobileScale : 1.2,
                    portraitScale : 1.2
                }, autoClose);
            }
        })];

    private constructor() {
        if(CreepyCarnivalTwoGameModuleConfig.instance) {
            throw new Error("CreepyCarnivalTwoGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    SERVER_PARSER:() => ServerDataParser = () => new CreepyCarnivalTwoServerDataParser();

    REEL_AREA_VIEW:() => ReelAreaView = () => new CreepyCarnivalTwoReelAreaView();

    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => new CreepyCarnivalTwoParsedInitData(data, <CreepyCarnivalTwoServerDataParser>dataParser);
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => new CreepyCarnivalTwoParsedGameData(data, <CreepyCarnivalTwoServerDataParser>dataParser);

    SPIN_CONTROLLER:() => SpinController = () => new CreepyCarnivalTwoSpinController();

    REEL_CONTROLLER:(reelId:number) => ReelController = reelId => new CreepyCarnivalTwoReelController(reelId);

    REEL_PART_CREATOR:() => ReelPartCreator = () => new ReelPartCreator(
        (symName:string, reelId:number, state?:ISymbolStateConfig):StateReelSymbol => {
            return new StateReelSymbol(symName, reelId, state);
        });

    INTRO_VIEW:(onClickCallback:() => void) => CreepyCarnivalTwoIntroView =
        (onClickCallback:() => void) => new CreepyCarnivalTwoIntroView({
            layer : CreepyCarnivalTwoGameConfig.instance.LAYERS.INTRO.name,
            onButtonClickCallback : onClickCallback,
            resourceGroup : ResourcesGroupName.INTRO,
            backgroundTextures : {
                desktop : {landscape : CreepyCarnivalTwoGameAssets.INTRO_BACKGROUND},
            },
            mobileScale : 1.2,
            portraitScale : 1.7
        });

    INDIVIDUAL_WIN_PRESENTATION:() => BetLineWinIndividualWPController = () => new CCTwoIndividualPController({
        symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
            return 0;
        }
    });

    GAME_FEATURE_CREATOR:() => void = () => {
        CreepyCarnivalTwoGameModuleConfig.starMeter = new CCTwoStarMeter();
        CreepyCarnivalTwoGameModuleConfig.wildStarSpin = new CCTWildStarSpinView();
        CreepyCarnivalTwoGameModuleConfig.starStatusScreen = new CCTwoStarStatusScreen();
        CreepyCarnivalTwoGameModuleConfig.background = new StillImageBackground({
            layer : GameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {
                    image : CreepyCarnivalTwoGameAssets.MAIN_GAME_BACKGROUND
                },
                RESPIN_MAIN : {
                    image : CreepyCarnivalTwoGameAssets.MAIN_GAME_BACKGROUND
                },
                RESPIN_FREESPIN : {
                    image : CreepyCarnivalTwoGameAssets.FREESPIN_GAME_BACKGROUND
                },
                FREESPIN : {
                    image : CreepyCarnivalTwoGameAssets.FREESPIN_GAME_BACKGROUND
                },
                STAR_SPIN : {
                    image : CreepyCarnivalTwoGameAssets.STAR_SPIN_BACKGROUND
                }
            },
            stretch : false
        });

        CreepyCarnivalTwoGameModuleConfig.multiplierIndicator = new CCTwoMultiplierIndicator();
        CreepyCarnivalTwoGameModuleConfig.reelArea = new StillImageBackground({
            layer : GameConfig.instance.LAYERS.REEL_BACKGROUND.name,
            backgroundImages : {
                NORMAL : {
                    image : CreepyCarnivalTwoGameAssets.REEL_AREA,
                    offset : new PIXI.Point(GameConfig.instance.REEL_AREA_POS_X - 22, GameConfig.instance.REEL_AREA_POS_Y)
                },
                RESPIN_MAIN : {
                    image : CreepyCarnivalTwoGameAssets.REEL_AREA,
                    offset : new PIXI.Point(GameConfig.instance.REEL_AREA_POS_X - 22, GameConfig.instance.REEL_AREA_POS_Y)
                },
                RESPIN_FREESPIN : {
                    image : CreepyCarnivalTwoGameAssets.REEL_AREA,
                    offset : new PIXI.Point(GameConfig.instance.REEL_AREA_POS_X - 22, GameConfig.instance.REEL_AREA_POS_Y)
                },
                FREESPIN : {
                    image : CreepyCarnivalTwoGameAssets.REEL_AREA,
                    offset : new PIXI.Point(GameConfig.instance.REEL_AREA_POS_X - 22, GameConfig.instance.REEL_AREA_POS_Y)
                },
                STAR_SPIN : {
                    image : CreepyCarnivalTwoGameAssets.REEL_AREA,
                    offset : new PIXI.Point(GameConfig.instance.REEL_AREA_POS_X - 22, GameConfig.instance.REEL_AREA_POS_Y)
                },

            },
            stretch : false
        });
        CreepyCarnivalTwoGameModuleConfig.backgroundM = new CCTwoBackground({
            layer : CreepyCarnivalTwoGameConfig.instance.LAYERS.LOGO.name
        });
        CreepyCarnivalTwoGameModuleConfig.bulbs = new CCTwoBulb();
        CreepyCarnivalTwoGameModuleConfig.betLinesView = new CCTwoBetlinesView(
            {
                map : [
                    22, 2, 24, 4, 26, 6, 32, 12, 35, 1, 37, 8, 38, 9, 21, 3, 23, 5, 25, 7,// left
                    31, 16, 33, 19, 34, 20, 36, 10, 27, 11, 28, 14, 29, 15, 30, 13, 39, 17, 40, 18 // right
                ]
            },
            (index:number):CCTwoTextBetLineNumber => {
                return new CCTwoTextBetLineNumber(index, {
                    layer : GameConfig.instance.LAYERS.BET_LINES.name,
                    width : 40,
                    height : 40,
                    horizontalPadding : GameConfig.instance.REEL_AREA_POS_X + 38,
                    // verticalPadding: [
                    //     GameConfig.instance.REEL_AREA_POS_Y + 10,
                    //     (GameConfig.instance.GAME_HEIGHT - (GameConfig.instance.REEL_AREA_POS_Y + GameConfig.instance.REEL_AREA_HEIGHT)-20)
                    // ],
                    verticalPadding : [122, 200],
                    textStyleNormal : {
                        fontFamily : "Insane Rodeo Bold",
                        fontSize : 23,
                        fill : "#3A220C"
                    },
                    textStyleWin : {
                        fontFamily : "Insane Rodeo Bold",
                        fontSize : 23,
                        fill : "#FFDDD4",
                        padding : 4
                    },
                    freeSTextStyleNormal : {
                        fontFamily : "Insane Rodeo Bold",
                        fontSize : 23,
                        fill : "#D76478"
                    },
                    freeSTextStyleWin : {
                        fontFamily : "Insane Rodeo Bold",
                        fontSize : 23,
                        fill : "#FFDDD4",
                        padding : 4
                    },
                    textWinScale : 1
                });
            },
            (index:number, numberPosition:number[], betLineData:number[]):CCTwoPolyBetLine => {
                return new CCTwoPolyBetLine(index, numberPosition, betLineData, {
                    staticLineLayer : GameConfig.instance.LAYERS.BET_LINES.name,
                    styles : [
                        {
                            "lineWidth" : 6,
                            "color" : 0x000000,
                            "alpha" : 0.5
                        },
                        {
                            "lineWidth" : 4,
                            "color" : 0xD9C368,
                            "alpha" : 1
                        }
                    ],
                    freeSpinStyles : [
                        {
                            "lineWidth" : 3,
                            "color" : 0x000000,
                            "alpha" : 1
                        },
                        {
                            "lineWidth" : 3,
                            "color" : 0xAC4673,
                            "alpha" : 1
                        }
                    ],
                    numberOffsetX : 150,
                    pointOverlapVerticalOffset : 8
                });
            }
        );

        StageManager.legacyScaling = true;
    };
}